<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="container" v-if="user">
      <div class="row">
        <div class="col-3 detail">
          <h4>ข้อมูลทั่วไป</h4>
          <hr />
          <p>ชื่อ</p>
          <div class="mb-3">{{ user.firstName }}</div>
          <p>นามสกุล</p>
          <div class="mb-3">{{ user.lastName }}</div>
          <p>เพศ</p>
          <div class="mb-3">{{ user.gender }}</div>
          <p>วันเกิด</p>
          <div class="mb-3">{{ user.birthDate }}</div>
          <p>บัตรประชาชน / Passport</p>
          <div class="mb-3">
            <button
              v-if="!isButtonHidden"
              class="button-content"
              @click="handleDecryptIdCard"
            >
              <span style="font-weight: bold">แสดงข้อมูล</span>
              <i class="fa fa-eye-slash" aria-hidden="true"></i>
            </button>
            <div v-if="user.identifierId" class="identifier-id">
              {{ user.identifierId }}
            </div>
          </div>
          <p>เบอร์โทรศัพท์</p>
          <div class="mb-3">{{ user.phoneNumber }}</div>
          <p>อีเมล</p>
          <div class="mb-3">{{ user.email }}</div>
          <p>สถานะ</p>
          <div class="mb-3">{{ user.status }}</div>
          <sc-button
            variant="secondary"
            class="mb-4"
            @click="handleClickChangePhoneNumber"
          >เปลี่ยนเบอร์โทรศัพท์</sc-button>
          <sc-button
            variant="secondary"
            class="mb-4"
            @click="handleClickChangeEmail"
          >เปลี่ยนอีเมล</sc-button>
          <sc-button
            variant="secondary"
            class="mb-4"
            @click="handleClickChangePassword"
          >เปลี่ยน Password</sc-button>
          <sc-button
            variant="danger"
            v-if="showReverifyButton"
            class="mb-4"
            @click="handleClickReverifyButton"
          >ให้ยืนยันตัวตนใหม่</sc-button>
          <sc-button
            variant="warning"
            v-if="showVerifyButton"
            class="mb-4"
            @click="handleClickVerifyUser"
          >ยืนยันตัวตนเป็นเจ้าของกรรมสิทธิ์</sc-button>
          <sc-button
            variant="amber"
            v-if="showVerifyButton"
            class="mb-4"
            @click="handleClickVerifyResident"
          >ยืนยันตัวตนเป็น ผู้อยู่อาศัย / ผู้เช่า</sc-button>
          <sc-button
            variant="danger"
            @click="handleClickDeleteUser"
            v-if="enableDelete"
          >ลบผู้ใช้</sc-button>
          <confirm
            :data="deleteUserDialog"
            v-if="deleteUserDialog.isShow"
            @confirm="handleConfirmDeleteUser"
          >
            <div class="text-center">
              <el-input placeholder="พิมพ์อีเมลผู้ใช้ที่ต้องการลบ" v-model="confirmDeleteUserEmail"></el-input>
            </div>
            <p class="text-danger text-center">
              กรุณาตรวจสอบความถูกต้องว่าเป็น
              <strong>ผู้ใช้ที่ต้องการจะลบ</strong>
              <br />หากยืนยันการ
              <strong>ลบ</strong>ไปแล้ว จะไม่สามารถย้อนกลับมาแก้ไขได้อีก
            </p>
            <el-checkbox v-model="isConfirmDeleteUserAgreement">
              <p class="checkboxConfirmMessage">
              ข้าพเจ้า
              <strong>{{adminFirstName}} {{adminLastName}}</strong>
              ยอมรับผิดชอบต่อความเสียหายใด ๆ ที่เกิดจากการลบผู้ใช้นี้
              </p>
            </el-checkbox>
            <p class="checkboxConfirmMessage text-center">
              หมายเหตุ - การลบ ‘ผู้ใช้’ มีการบันทึกประวัติการกระทำไว้
            </p>
          </confirm>
          <confirm
            :data="verifyDialog"
            v-if="verifyDialog.isShow"
            @confirm="handleConfirmVerifyUser"
          >
            <label class="lable">บัตรประชาชน / Passport</label>
            <el-input class="input" v-model="identifierId" />
          </confirm>
          <confirm
            :data="verifyResidentDialog"
            v-if="verifyResidentDialog.isShow"
            @confirm="handleConfirmVerifyResident"
          >
            <label class="lable">บัตรประชาชน / Passport</label>
            <el-input class="input" v-model="identifierId" />
          </confirm>
        </div>
        <div class="col-9">
          <h4>ข้อมูลบ้าน</h4>
          <hr />
          <div class="text-right">
            <sc-button variant="primary" @click="handleClickAdd">เพิ่มเข้าบ้าน</sc-button>
          </div>
          <div v-show="isAdding">
            <add-home v-model="addHomeForm"></add-home>
            <div class="text-right">
              <sc-button class="mr-2" @click="handleCancelAdd">ยกเลิก</sc-button>
              <sc-button variant="primary" @click="handleSaveAdd">บันทึก</sc-button>
            </div>
          </div>
          <div class="bottom-right">
            <sc-button variant="primary" :route="userLogButton.route">{{userLogButton.label}}</sc-button>
          </div>
          <home-list class="mt-4" :homes="homes" @remove="handleRemove"></home-list>
          <p v-if="homes.length === 0" class="text-center">ไม่มีข้อมูล</p>
        </div>
      </div>
    </div>
    <confirm :data="confirmDialog" v-if="confirmDialog.isShow" @confirm="handleConfirm">
      <div class="text-center">
        <el-input placeholder="Password ใหม่" v-model="newPassword"></el-input>
      </div>
      <p class="text-danger text-center">
        กรุณาตรวจสอบข้อมูล
        <strong>ลูกบ้าน</strong>ว่าเป็น
        <strong>คนที่ต้องการจะเปลี่ยน Password</strong> ให้
        <br />หากกด
        <strong>บันทึก</strong>ไปแล้ว จะไม่สามารถย้อนกลับมาแก้ไขได้อีก
      </p>
    </confirm>
    <confirm
      :data="changeEmailConfirmDialog"
      v-if="changeEmailConfirmDialog.isShow"
      @confirm="handleChangeEmailConfirm"
    >
      <div class="text-center">
        <el-input placeholder="อีเมลใหม่" v-model="newEmail"></el-input>
      </div>
    </confirm>
    <confirm
      :data="changePhoneNumberDialog"
      v-if="changePhoneNumberDialog.isShow"
      @confirm="handleConfirmPhoneNumber"
    >
      <div class="text-center">
        <el-input placeholder="เบอร์โทรศัพท์ใหม่" v-model="newPhoneNumber"></el-input>
      </div>
    </confirm>
  </page-wrapper>
</template>

<script>
import { Input, Checkbox } from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { toLocaleTH } from "@/lib/dateTime";
import { DateTime } from "luxon";
import { genderMapper, userRole, userRoleMapper } from "@/lib/mapper";
import HomeList from "../components/HomeList";
import AddHome from "../components/AddHome";
import { backendAdminClient } from "@/dependencies";

export default {
  components: {
    PageWrapper,
    ScButton,
    AddHome,
    HomeList,
    "el-input": Input,
    "el-checkbox": Checkbox
  },
  data() {
    const title = "ข้อมูลผู้ใช้";
    const user = null;
    const homes = null;
    const addHomeForm = {
      project: null,
      homes: [],
      role: null
    };
    const isAdding = false;
    const enableDelete = false;
    const changePhoneNumberDialog = {
      isShow: false,
      title: "เปลี่ยนแปลงเบอร์โทรศัพท์",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก"
    }
    const confirmDialog = {
      isShow: false,
      title: "เปลี่ยนแปลง Password",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก"
    };
    const changeEmailConfirmDialog = {
      isShow: false,
      title: "เปลี่ยนแปลงอีเมล",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก"
    }
    const verifyDialog = {
      isShow: false,
      title: "ยืนยันตัวตนเป็นเจ้าของกรรมสิทธิ์",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "ยืนยัน"
    };
    const verifyResidentDialog = {
      isShow: false,
      title: "ยืนยันตัวตนเป็น ผู้อยู่อาศัย / ผู้เช่า",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "ยืนยัน"
    };
    const userLogButton = {
      label: "ดูประวัติการเปลี่ยนแปลง",
      route: { name: "UserLogPage" }
    };
    const newEmail = "";
    const newPassword = "";
    const identifierId = "";
    const deleteUserDialog = {
      isShow: false,
      title: "ลบผู้ใช้",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "ยืนยัน"
    };
    const newPhoneNumber = "";
    const confirmDeleteUserEmail = "";
    const isConfirmDeleteUserAgreement = false;
    const isOwner = true;


    return {
      title,
      user,
      homes,
      addHomeForm,
      isAdding,
      enableDelete,
      changeEmailConfirmDialog,
      changePhoneNumberDialog,
      confirmDialog,
      verifyDialog,
      userLogButton,
      newEmail,
      newPassword,
      identifierId,
      deleteUserDialog,
      newPhoneNumber,
      confirmDeleteUserEmail,
      isConfirmDeleteUserAgreement,
      verifyResidentDialog,
      isOwner,
      isButtonHidden: false,
    };
  },
  computed: {
    showReverifyButton() {
      return this.user.isVerifiedAsVisitor;
    },
    showVerifyButton() {
      return !this.user.isVerified;
    },
    adminFirstName() {
      return localStorage.getItem("adminFirstName");
    },
    adminLastName() {
      return localStorage.getItem("adminLastName");
    },
    userId() {
      const { id } = this.$route.params;

      return parseInt(id);
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      const permission = JSON.parse(localStorage.getItem("adminRolePermission"));
      if (permission.features.find(x => x.featureId === 28) !== undefined) { // enable delete user button
        this.enableDelete = true;
      }
      this.setupData();
    },
    async setupData() {
      await this.setupUser();
      await this.setupIdentifierId();
    },
    async setupIdentifierId() {
      this.identifierId = this.user.identifierId;
    },
    async setupUser() {
      const data = await this.fetchUser();
      const { user_profile: profile, has_user_verify } = data;
      const identifierId = '';
      const isVerified = profile.is_verified;
      const isVerifiedAsVisitor = isVerified && !Boolean(has_user_verify);

      const user = {
        email: data.email,
        firstName: profile.first_name,
        lastName: profile.last_name,
        gender: profile.gender ? genderMapper[profile.gender.toLowerCase()] : "-",
        birthDate: profile.birth_date
          ? toLocaleTH(DateTime.fromISO(profile.birth_date)).toFormat(
              "dd MMMM yyyy"
            )
          : "-",
        identifierId,
        phoneNumber: profile.mobile_number || "-",
        status: isVerified ? "ยืนยันตัวตนแล้ว" : "ยังไม่ยืนยันตัวตน",
        isVerified,
        isVerifiedAsVisitor
      };

      this.user = user;
      this.homes = (data.homes || []).map(home => {
        return {
          id: home.home_id,
          projectId: home.project_id,
          userRole: home.user_role,
          addressNumber: home.address_no,
          projectName: `${home.project_name} (${home.project_code})`
        };
      });
    },
    async fetchUser() {
      const response = await baanRueJaiClient.admin.users.get(this.userId);

      return response.data.result;
    },
    async inviteUserToHome() {
      const { project, homes, role } = this.addHomeForm;
      const homeIds = homes.map(({ homeId }) => homeId);
      const projectId = project.projectId;
      const params = {
        homeIds,
        projectId,
        role
      };

      await baanRueJaiClient.admin.users.invite(this.userId, params);
    },
    async handleClickReverifyButton() {
      if (!confirm("ยืนยันการให้ผู้ใช้ไปยืนยันตัวตนใหม่")) {
        return;
      }

      if (!this.user.isVerified) {
        alert("ผู้ใช้ไม่ได้ยืนยันตัวตนอยู่แล้ว");
        return;
      }

      if (!this.user.isVerifiedAsVisitor) {
        alert(
          "ผู้ใช้ยืนยันตัวตนเป็นเจ้าของกรรมสิทธิ์ หรือ เคยถูกเชิญเข้าบ้านแล้ว"
        );
      }

      await baanRueJaiClient.admin.users.reverify({ userId: this.userId });
      await this.setupData();
    },
    async handleClickAdd() {
      this.isAdding = true;
    },
    async handleCancelAdd() {
      this.resetForm();
      this.isAdding = false;
    },
    validateAddHomeForm() {
      if (
        this.addHomeForm.project === null
        || this.addHomeForm.homes.length === 0
        || this.addHomeForm.role === null
      ) {
        return false;
      }

      return true;
    },
    async handleSaveAdd() {
      const validRoleForVerifiedUser = [
        userRole.OWNER,
        userRole.RESIDENT,
        userRole.RENTER
      ];

      if (
        !this.user.isVerified &&
        validRoleForVerifiedUser.includes(this.addHomeForm.role)
      ) {
        const message = `ผู้ใช้ยังไม่ยืนยันตัวตน! ต้องการเพิ่ม ${this.user.firstName} ${this.user.lastName} เข้าโครงการ ${this.addHomeForm.project.projectName} ใช่หรือไม่?`;

        if (!confirm(message)) {
          return;
        }
      }

      if (!this.validateAddHomeForm()) {
        alert("กรุณาเลือกโครงการ บ้าน และสิทธิ์");
        return;
      }

      try {
        await this.inviteUserToHome();
        this.addHomeForm = { homes: [], project: null, role: null };
        this.isAdding = false;
        await this.setup();
      } catch (err) {
        console.error(err);
        alert(err.response.data.message);
      }
    },
    async resetForm() {
      this.addHomeForm = {
        homes: [],
        role: null,
        project: null
      };
    },
    async handleRemove(home) {
      const message = `ยืนยันการไล่ ${this.user.firstName} ${this.user.lastName} ออกจากบ้านเลขที่ ${home.addressNumber} โครงการ ${home.projectName}`;

      if (!confirm(message)) {
        return;
      }

      try {
        await this.uninvite(home);
        await this.setup();
      } catch (err) {
        console.error(err);
        alert("ผิดพลาด");
      }
    },
    async uninvite(home) {
      const homeIds = [home.id];
      const params = { homeIds, role: home.userRole };

      Object.keys(userRoleMapper).forEach(key => {
        if (userRoleMapper[key] === home.userRole) {
          params.role = key;
          return;
        }
      });

      await baanRueJaiClient.admin.users.uninvite(this.userId, params);
    },
    handleClickChangeEmail() {
      this.changeEmailConfirmDialog.isShow = true;
    },
    handleClickChangePhoneNumber() {
      this.changePhoneNumberDialog.isShow = true;
    },
    handleClickChangePassword() {
      this.confirmDialog.isShow = true;
    },
    handleClickVerifyUser() {
      this.verifyDialog.isShow = true;
    },
    handleClickVerifyResident() {
      this.verifyResidentDialog.isShow = true;
    },
    async verify() {
      const params =
        this.identifierId.length === 13
          ? { citizenId: this.identifierId, isOwner: this.isOwner }
          : { passportNumber: this.identifierId, isOwner: this.isOwner };

      await baanRueJaiClient.admin.users.postVerify(this.userId, params);
    },
    async handleConfirmVerifyUser(isConfirm) {
      if (!isConfirm) {
        this.verifyDialog.isShow = false;
        this.identifierId = this.user.identifierId;
        return;
      }

      try {
        await this.verify();
        this.verifyDialog.isShow = false;
        await this.setup();
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async handleConfirmVerifyResident(isConfirm) {
      if (!isConfirm) {
        this.verifyResidentDialog.isShow = false;
        this.identifierId = this.user.identifierId;
        return;
      }

      try {
        this.isOwner = false;
        await this.verify();
        this.verifyResidentDialog.isShow = false;
        await this.setup();
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async handleChangeEmailConfirm(isConfirm) {
      if (!isConfirm) {
        this.changeEmailConfirmDialog.isShow = false;
        this.newEmail = "";
        return;
      }

      try {
        const response = await baanRueJaiClient.admin.users.putEmail(this.userId, {
          email: this.newEmail
        });

        this.newEmail = "";
        this.changeEmailConfirmDialog.isShow = false;
        alert("เปลี่ยนอีเมลเรียบร้อย");

        this.setup();
      } catch (error) {
        error.response.data.errorCode === "EMAIL_ALREADY_USED"
          ? alert(error.response.data.message)
          : alert("ไม่สามารถเปลี่ยนอีเมลได้");
        console.error(error);
      }
    },
    async handleConfirm(isConfirm) {
      if (!isConfirm) {
        this.confirmDialog.isShow = false;
        this.newPassword = "";
        return;
      }

      if (!confirm("ยืนยันการเปลี่ยน Password")) {
        return;
      }

      try {
        const response = await baanRueJaiClient.admin.users.putPassword(this.userId, {
          password: this.newPassword
        });

        this.newPassword = "";
        this.confirmDialog.isShow = false;
        alert("เปลี่ยน Password เรียบร้อย");
      } catch (error) {
        console.error(error);
        alert("ไม่สามารถเปลี่ยน Password ได้");
      }
    },
    async handleConfirmPhoneNumber(isConfirm) {
      if (!isConfirm) {
        this.changePhoneNumberDialog.isShow = false;
        this.newPhoneNumber = "";
        return;
      }

      try {
        const response = await baanRueJaiClient.admin.users.putPhoneNumber(this.userId, {
          mobileNumber: this.newPhoneNumber
        });

        this.newPhoneNumber = "";
        this.changePhoneNumberDialog.isShow = false;
        alert("เปลี่ยนเบอร์โทรศัพท์เรียบร้อย");

        this.setup();
      } catch (error) {
        console.error(error);
        alert("ไม่สามารถเปลี่ยนเบอร์โทรศัพท์ได้");
      }
    },
    handleClickDeleteUser() {
      this.deleteUserDialog.isShow = true
    },
    async handleConfirmDeleteUser(isConfirm) {
      if (!isConfirm) {
        this.confirmDeleteUserEmail = "";
        this.isConfirmDeleteUserAgreement = false;
        this.deleteUserDialog.isShow = false;
        return;
      }

      if (!this.isConfirmDeleteUserAgreement) {
        alert("กรุณายอมรับข้อตกลงการลบผู้ใช้");
        return;
      }

      if (this.confirmDeleteUserEmail !== this.user.email) {
        alert("กรุณาพิมพ์อีเมลให้ตรงกับผู้ใช้ที่ต้องการลบ");
        return;
      }

      try {
        const response = await baanRueJaiClient.admin.users.deleteUser(this.userId);

        alert("ลบผู้ใช้เรียบร้อย");

        this.$router.push({ name: "UserListPage" });
      } catch (error) {
        console.error(error);
        alert("ไม่สามารถลบผู้ใช้ได้");
      }
    },
    async handleDecryptIdCard() {
      try {
       const user_id = this.userId
       const response = await backendAdminClient.user.getDecryptedIdCard(user_id);

        this.user.identifierId = response.data.result.id_card;
        this.isButtonHidden = true;
      } catch (error) {
        alert("ไม่สามารถเข้าถึงได้");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.detail {
  border-right: $border;
}
.bottom-right {
  right: 0;
  bottom: 0;
  position: absolute;
}

.checkboxConfirmMessage {
  font-size: 15px;
}

.button-content {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  font-size: 16px;
  color: #4a4a4a;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.button-content:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/users/pages/UserDetailPage.vue